import {useTranslation} from "react-i18next";
import React, {useMemo} from "react";
import {localDateTimeFormatter} from "../../../utils/DateTimeUtils";
import TableGrid from "../../basics/table-grid/TableGrid";
import ChangeList from "./ChangeList";
import AnimalReferenceDocumentModalGrid from "../../grids/animal-reference-document/AnimalReferenceDocumentModalGrid";

const CommentCell = ({value, object}) => {
    if (object?._rfidChangeAnimal) {
        return (
            <span className="d-flex justify-content-center align-items-center">
                <AnimalReferenceDocumentModalGrid
                    object={object._rfidChangeAnimal}
                    value={object._rfidChangeAnimal?.AnmNo1}
                />
                {" - "}
                {value}
            </span>
        );
    }
    return value;
};

export default ({data, isGroup}) => {
    const {t} = useTranslation();

    const headers = useMemo(() => {
        return [
            {
                name: t("date"),
                field: "timestamp",
                valueFormatter: localDateTimeFormatter,
                itemClassName: "text-start",
            },
            isGroup
                ? {
                      name: t("newReports.forageForAnimal.animal"),
                      field: "subgroupName",
                      colWidth: 2,
                      itemClassName: "text-start",
                  }
                : null,
            {
                name: t("eventGrid.operator"),
                field: "invokedBy.name",
                colWidth: 2,
                itemClassName: "text-start",
            },
            {
                name: t("controlLists.mainView.description"),
                field: "title",
                colWidth: 5,
                itemClassName: "text-start",
            },
            {
                name: t("logView.changes"),
                field: "changes",
                component: ChangeList,
                colWidth: 3,
                itemClassName: "text-start",
            },
            {
                name: t("comment"),
                field: "comment",
                component: CommentCell,
                colWidth: 5,
                itemClassName: "text-end",
            },
        ].filter((o) => o);
    }, [t, isGroup]);

    return (
        <TableGrid
            className={"allow-multiline"}
            data={data}
            showPagination={true}
            paginationItems={25}
            headers={headers}
        />
    );
};
